import { FormattedMessage as T, useIntl } from "react-intl";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import { useQuery } from "react-query";
import Loader from "components/Loader";
import { Alert, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import EmailTemplateForm from "./EmailTemplateForm";
import useTitle from "hooks/useTitle";

export default function EmailTemplateEditForm() {
  const { formatMessage: t } = useIntl();
  const { emailTemplatesUrl, emailService } = useGlobalContext();
  const { id } = useParams<{ id: string }>();

  const { data, isLoading, isError } = useQuery(["getEmailTemplate", id], () =>
    emailService.getEmailTemplate(id!)
  );

  const emailTemplate = data?.data;
  useTitle(emailTemplate?.name || t({ id: "updateEmailTemplate" }));

  if (isLoading) return <Loader />;
  if (isError) {
    return (
      <Box mt={4}>
        <Alert severity="error">
          <T id="fetchError" />
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <RedirectBackButton
        redirectRoute={emailTemplatesUrl()}
        labelKey="backToListButtonLabel"
      />
      <h2>
        <T id="editEmailTemplate" />
      </h2>
      <EmailTemplateForm
        submitLabel={t({ id: "updateEmailTemplate" })}
        emailTemplate={emailTemplate}
      />
    </>
  );
}
